import { useContext } from 'react';
import { UserIdentityContext } from '../contexts/user_identity_context';

const useUserIdentity = () => {
    return useContext(UserIdentityContext);
};

export default useUserIdentity;
